<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid-not-index
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          @items="storeItems"
        >
          <template v-slot:alternative-columns>
            <thead class="vs-table--thead">
              <vs-th style="width: 3%">#</vs-th>
              <vs-th style="width: 80%">{{ $t("SerialNumbers") }}</vs-th>
              <vs-th style="width: 17%">
                <div class="flex items-center gap-2">
                  <span>{{ $t("Select") }}</span>
                  <vs-checkbox
                    @click="selectAllPossibleSerials($event)"
                    :checked="
                      chosenSerialsCurrent.length ===
                      modelForShowCurrent.remainingCountForCheckout
                    "
                  >
                  </vs-checkbox>
                </div>
              </vs-th>
            </thead>
          </template>

          <template slot-scope="{ row, index }">
            <td style="width: 15%">
              {{ index + 1 }}
            </td>
            <td style="width: 70%">
              {{ row }}
              <!-- {{ row.serial }} -->
            </td>
            <td style="width: 15%">
              <vs-checkbox
                @click="clickCheckBox($event, row)"
                :disabled="MaximumCount <= 0"
                :checked="chosenSerialsCurrent.includes(row)"
              >
              </vs-checkbox>
            </td>
          </template>
        </data-grid-not-index>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGridNotIndex from "@/components/datagrid/DataGridNotIndex";

export default {
  name: "warehouseManagement_CheckOutTransactions_Serials",
  components: {
    DataGridNotIndex,
  },
  props: {
    lastIndexRegistered: { default: 0 },
    modelForInternalApi: { default: {} },
    modelForShowCurrent: { default: [] },
    serialService: { default: "" },
  },
  data() {
    return {
      startIndex: 0,
      MaximumCount: 0,
      maximumCountForSelectAllFeature: 0,
      chosenSerialsCurrent: [],
      modelForTransfer: [],
      newListSerialsInfo: [],
      gridDataSource: { data: [] },
      gridSearchData: {},
      serials: [],
    };
  },
  methods: {
    clickCheckBox(event, val) {
      if (event.target.checked) {
        this.startIndex += 1;
        this.MaximumCount -= 1;
        this.modelForTransfer.push({
          serial: val,
          index: this.startIndex,
        });
        // this.newSerialsInfo.push({
        //   serial: val,
        //   index: this.startIndex
        // });
        this.chosenSerialsCurrent.push(val);
      } else {
        let index = this.chosenSerialsCurrent.indexOf(val);
        this.chosenSerialsCurrent.splice(index, 1);
        this.modelForTransfer.forEach((elem, index1) => {
          if (elem.serial == val) {
            this.modelForTransfer.splice(index1, 1);
          }
        });
        this.MaximumCount += 1;
      }
      this.$emit("update", this.modelForTransfer);
    },
    storeItems(items) {
      this.serials = items;
    },
    isThisSerialSelected(serial) {
      return this.chosenSerialsCurrent.includes(serial);
    },
    nextAvailableSerialForSelectionIndex(index) {
      let currentIndex = index;
      while (this.isThisSerialSelected(this.serials[currentIndex])) {
        currentIndex++;
        // Loop back to the start if we reach the end of the array.
        if (currentIndex >= this.serials.length) currentIndex = 0;
        // Prevent infinite loop if all serials are chosen.
        if (currentIndex === index) return -1;
      }
      // currentIndex is now an unselected index.
      return currentIndex;
    },
    selectAllPossibleSerials(event) {
      if (event.target.checked) {
        for (
          let i = 0;
          i < this.maximumCountForSelectAllFeature && this.MaximumCount > 0;
          i++
        ) {
          this.clickCheckBox(
            { target: { checked: true } },
            this.serials[this.nextAvailableSerialForSelectionIndex(i)]
          );
        }
      } else {
        // Deselect all selected serials:
        for (let serial of [...this.chosenSerialsCurrent]) {
          let serialIndex = this.serials.indexOf(serial);
          this.clickCheckBox(
            { target: { checked: false } },
            this.serials[serialIndex]
          );
        }
        // Reset maximumCountForSelectAllFeature on deselectAll
        this.maximumCountForSelectAllFeature =
          this.modelForShowCurrent.remainingCountForCheckout;
      }
    },
    // if (event.target.checked) {
    //   this.startIndex += 1;
    //   this.MaximumCount -= 1;
    //   this.modelForTransfer.push({
    //     serial: val,
    //     index: this.startIndex
    //   });
    //   this.newListSerialsInfo.push({
    //     serial: val,
    //     index: this.startIndex
    //   });
    //   // this.$emit("addSerial", this.newListSerialsInfo);
    //   this.chosenSerialsCurrent.push(val);
    // } else {
    //   for (let index = 0; index < this.newListSerialsInfo.length; index++) {
    //     if (this.newListSerialsInfo[index].serial == val) {
    //       this.newListSerialsInfo.splice(index, 1);
    //       break;
    //     }
    //   }
    //   // let index = this.chosenSerialsCurrent.indexOf(val);
    //   // this.chosenSerialsCurrent.splice(index, 1);
    //   // this.modelForTransfer.forEach((elem, index1) => {
    //   //   if (elem.serial == val) {
    //   //     this.modelForTransfer.splice(index1, 1);
    //   //   }
    //   // });
    //   this.MaximumCount += 1;
    // }
    // this.$emit("updateModel", this.newListSerialsInfo);
    // }
  },

  mounted() {
    this.gridDataSource = {
      type: "app",
      service:
        "/Inventory/api/SerialsOfStockQuery/" +
        this.modelForInternalApi.storeId +
        "/" +
        this.modelForInternalApi.shelveId +
        "/" +
        this.modelForInternalApi.stockId,
    };
    setTimeout(() => {
      this.$refs.grid.renderGrid();
    }, 200);
    this.newListSerialsInfo = [];
    this.startIndex = this.lastIndexRegistered;
    this.MaximumCount =
      this.modelForShowCurrent.remainingCountForCheckout -
      this.modelForShowCurrent.serialsInfo.length;
    this.maximumCountForSelectAllFeature =
      this.modelForShowCurrent.remainingCountForCheckout -
      this.modelForShowCurrent.serialsInfo.length;
    this.modelForTransfer = this.modelForShowCurrent.serialsInfo;
    this.modelForShowCurrent.serialsInfo.forEach((elem) => {
      this.chosenSerialsCurrent.push(elem.serial);
    });
  },
};
</script>
